import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { FormGroup, FormRow, Row, Textarea } from "styles/forms/main";
import { RejectionReason, SelectWithSearch, VerifyComponent } from "components";
import { getUserRoles } from "modules/auth/slice";
import { SUPPLIER_PARTNER_TYPE, SUPPLIER_TYPE, TRUCK_TYPE } from "../staticData";
import { getAllGovernorates, getAllOrganizations } from "../config/api";
import { useParams, useHistory } from "react-router-dom";

function WorkingInfo({
    newSupplierData,
    handleSupplierDetailsChange,
    isQARole,
    isEditable,
    errorList,
    handleObjections,
    objections,
    isAuthorizedToCreate,
}) {
    const [allGovernorates, setAllGovernorates] = useState([]);
    const [allOrganizations, setAllOrganizations] = useState([]);
    const getCurrentUserRole = useSelector(getUserRoles()).filter((role) => role === "reviewer");
    const [objection, setObjections] = useState({});
    const isUserSupplierPartner = useSelector(getUserRoles())?.includes("supplier_partner_account_manager")
    const { id } = useParams()
    const { location } = useHistory();

    const selectedOrganizationId = location?.pathname?.includes("/database/clients") && id ? id : null



    const handleFetchGovernorates = async () => {
        const data = await getAllGovernorates();
        setAllGovernorates(data);
    };
    const handleFetchOrganizations = async () => {
        const data = await getAllOrganizations();
        setAllOrganizations(data);
    };

    useEffect(() => {
        handleFetchGovernorates();
        if (isUserSupplierPartner) {
            handleFetchOrganizations()
        }
    }, [isUserSupplierPartner]);

    const openObjectionhandler = (fieldName) => {
        setObjections({
            ...objection,
            [fieldName]: {
                haveobjection: true,
                verified: false,
            },
        });
    };
    const handleVerify = (fieldName, item, section, category) => {
        setObjections({
            ...objection,
            [fieldName]: {
                verified: true,
                haveobjection: false,
            },
        });
        handleObjections(null, item, section, category, true);
    };

    const renderObjection = (objectionName) => {
        if (objections && objections[objectionName] && isAuthorizedToCreate) {
            return <RejectionReason content={objections[objectionName]} />;
        }
        return null;
    };


    return (
        <>
            <FormRow>
                <FormGroup>
                    <Row>
                        <SelectWithSearch
                            isEditable={isUserSupplierPartner ? !isUserSupplierPartner : isEditable}
                            isMulti={false}
                            label="Supplier Type"
                            name="supplierType"
                            options={isUserSupplierPartner ? SUPPLIER_PARTNER_TYPE : SUPPLIER_TYPE}
                            handleChange={(value) =>
                                handleSupplierDetailsChange(value, "supplierType")
                            }
                            value={newSupplierData?.supplierType}
                            placeholder="Select"
                            required
                            errorMessage={errorList?.supplierType && errorList?.supplierType}
                        />
                        {getCurrentUserRole[0] === "reviewer" && isQARole && (
                            <VerifyComponent
                                objectionHandler={() => openObjectionhandler("supplierType")}
                                handleVerify={() =>
                                    handleVerify(
                                        "supplierType",
                                        "Supplier Type",
                                        "Working Info - Supplier",
                                        "supplier_profile"
                                    )
                                }
                                verifed={
                                    objection?.supplierType?.verified
                                        ? objection?.supplierType?.verified
                                        : false
                                }
                                objection={
                                    objection?.supplierType?.haveobjection
                                        ? objection?.supplierType?.haveobjection
                                        : false
                                }
                            />
                        )}
                        {renderObjection("Supplier Type")}
                    </Row>
                    {objection?.supplierType?.haveobjection && (
                        <Textarea
                            autoFocus
                            required
                            onBlur={(e) => {
                                handleObjections(
                                    e,
                                    "Supplier Type",
                                    "Working Info - Supplier",
                                    "supplier_profile",
                                    false
                                );
                            }}
                        />
                    )}
                </FormGroup>
                <FormGroup>
                    <Row>
                        <SelectWithSearch
                            isEditable={isEditable}
                            isMulti
                            label="Truck Types"
                            name="truckTypes"
                            options={TRUCK_TYPE}
                            handleChange={(value) =>
                                handleSupplierDetailsChange(value, "truckTypes")
                            }
                            value={newSupplierData?.truckTypes}
                            placeholder="Select"
                            required
                            errorMessage={errorList?.truckTypes && errorList?.truckTypes}
                        />
                        {getCurrentUserRole[0] === "reviewer" && isQARole && (
                            <VerifyComponent
                                objectionHandler={() => openObjectionhandler("truckTypes")}
                                handleVerify={() =>
                                    handleVerify(
                                        "truckTypes",
                                        "Truck Types",
                                        "Working Info - Supplier",
                                        "supplier_profile"
                                    )
                                }
                                verifed={
                                    objection?.truckTypes?.verified
                                        ? objection?.truckTypes?.verified
                                        : false
                                }
                                objection={
                                    objection?.truckTypes?.haveobjection
                                        ? objection?.truckTypes?.haveobjection
                                        : false
                                }
                            />
                        )}
                        {renderObjection("Truck Types")}
                    </Row>
                    {objection?.truckTypes?.haveobjection && (
                        <Textarea
                            autoFocus
                            required
                            onBlur={(e) => {
                                handleObjections(
                                    e,
                                    "Truck Types",
                                    "Working Info - Supplier",
                                    "supplier_profile",
                                    false
                                );
                            }}
                        />
                    )}
                </FormGroup>
            </FormRow>
            <FormRow>
                <FormGroup>
                    <Row>
                        <SelectWithSearch
                            options={allGovernorates}
                            isEditable={isEditable}
                            isMulti
                            label="Working Governorates"
                            name="workingGovernorates"
                            handleFilter={(filter) => getAllGovernorates(filter)}
                            handleChange={(value) =>
                                handleSupplierDetailsChange(value, "workingGovernorates")
                            }
                            value={newSupplierData?.workingGovernorates}
                            placeholder="Select"
                            errorMessage={
                                errorList?.workingGovernorates && errorList?.workingGovernorates
                            }
                            required
                        />
                        {getCurrentUserRole[0] === "reviewer" && isQARole && (
                            <VerifyComponent
                                objectionHandler={() => openObjectionhandler("workingGovernorates")}
                                handleVerify={() =>
                                    handleVerify(
                                        "workingGovernorates",
                                        "Working Governate",
                                        "Working Info - Supplier",
                                        "supplier_profile"
                                    )
                                }
                                verifed={
                                    objection?.workingGovernorates?.verified
                                        ? objection?.workingGovernorates?.verified
                                        : false
                                }
                                objection={
                                    objection?.workingGovernorates?.haveobjection
                                        ? objection?.workingGovernorates?.haveobjection
                                        : false
                                }
                            />
                        )}
                        {renderObjection("Working Governate")}
                    </Row>
                    {objection?.workingGovernorates?.haveobjection && (
                        <Textarea
                            required
                            autoFocus
                            onBlur={(e) => {
                                handleObjections(
                                    e,
                                    "Working Governate",
                                    "Working Info - Supplier",
                                    "supplier_profile",
                                    false
                                );
                            }}
                        />
                    )}
                </FormGroup>
            </FormRow>
            {isUserSupplierPartner && <FormRow>
                <FormGroup>
                    <Row>
                        <SelectWithSearch
                            options={allOrganizations}
                            isEditable={selectedOrganizationId ? false : isEditable}
                            label="Logistics Partner"
                            name="organizationId"
                            handleFilter={(filter) => getAllOrganizations(filter)}
                            handleChange={(value) =>
                                handleSupplierDetailsChange(value, "organizationId")
                            }
                            value={allOrganizations?.find(organization => organization.value === newSupplierData?.organizationId?.value?.toString())}
                            placeholder="Select"
                        />

                    </Row>
                </FormGroup>
            </FormRow>}
        </>
    );
}

export default WorkingInfo;
